export class TextMapping {

    public modelIndex: number
    public textIndex: number
    public mappings: Map<number, number>
    public pendingSeparation: boolean

    constructor(private blockSeparatorLength: number) {

        this.pendingSeparation = false
        this.modelIndex = -1
        this.textIndex = 0
        this.mappings =new Map<number, number>()
    }

    public mapText(text: string) {
        const chars = [...text]

        chars.forEach(_c => {
            this.mappings.set(this.textIndex, this.modelIndex)
            this.textIndex++
            this.modelIndex++
        })

        this.pendingSeparation = true
    }

    separateIfNeeded() {
        if (this.pendingSeparation) {
            this.separate()
        }
    }

    separate() {
        this.textIndex += this.blockSeparatorLength
        this.pendingSeparation = false
    }

    increaseModel(nodeSize: number) {
        this.modelIndex += nodeSize
    }

    increaseSerializedText(textLength: number, nodeSize: number) {
        this.textIndex +=  textLength
        this.modelIndex += nodeSize
    }

    startBlock() {
        this.separateIfNeeded()
        this.modelIndex++
        if (this.textIndex > 0) {
            this.pendingSeparation = true
        }
    }

    endBlock() {
        this.modelIndex++
    }
}

